module.exports = __webpack_public_path__ + "img/380.e28aaafe.jpg";